<template>
	<div class="relative">
		<div class="vx-navbar-wrapper" :class="classObj">
			<vs-navbar
				class="vx-navbar navbar-custom navbar-skelton"
				:color="navbarColorLocal"
				:class="textColor"
			>
				<!-- SM - OPEN SIDEBAR BUTTON -->
				<feather-icon
					class="sm:inline-flex xl:hidden cursor-pointer p-2"
					icon="MenuIcon"
					@click.stop="showSidebar"
				/>

				<!--        <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" />-->

				<div
					v-if="
						$route.path === '/tickets' &&
							$store.state.auth.role !== 'client' &&
							$store.state.auth.role !== 'author'
					"
					class="search flex items-center ml-3"
				>
					<vs-input
						icon-after
						:placeholder="$t('searchById')"
						v-on:icon-click="filter"
						v-model="id"
						class="w-full"
						v-on:keyup.enter="filter"
					/>
					<vs-icon
						icon="search"
						@click="filter"
						class="search-icon"
					/>
				</div>

				<vs-spacer />

				<!--				<search-bar class="mr-4"/>-->
				<!-- primary -->
				<vs-dropdown
					v-if="$store.state.auth.role !== 'client'"
					vs-custom-content
					vs-trigger-click
					:fixed="true"
					class="cursor-pointer mr-5"
				>
					<div
						class="con-img flex items-center  ml-3"
						v-if="$i18n.locale === 'de'"
					>
						<img
							src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAA8AgMAAADtUfddAAAACVBMVEUAAADdAAD/zgDGIigcAAAAHElEQVR4AWMAgVEwCkJxgRElMyqzChcYSTKjMgBDzfIcJWmM/AAAAABJRU5ErkJggg=="
							alt="de"
							width="22"
							height="14"
							class=""
						/>
						<span class="ml-2">{{ $t("german") }}</span>
					</div>

					<div
						class="con-img flex items-center  ml-3"
						v-else-if="$i18n.locale === 'en'"
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 50 30"
							width="22"
							height="14"
						>
							<clipPath id="t">
								<path
									d="M25,15h25v15zv15h-25zh-25v-15zv-15h25z"
								/>
							</clipPath>
							<path d="M0,0v30h50v-30z" fill="#012169" />
							<path
								d="M0,0 50,30M50,0 0,30"
								stroke="#fff"
								stroke-width="6"
							/>
							<path
								d="M0,0 50,30M50,0 0,30"
								clip-path="url(#t)"
								stroke="#C8102E"
								stroke-width="4"
							/>
							<path
								d="M-1 11h22v-12h8v12h22v8h-22v12h-8v-12h-22z"
								fill="#C8102E"
								stroke="#FFF"
								stroke-width="2"
							/>
						</svg>

						<span class="ml-2">{{ $t("english") }}</span>
					</div>

					<div class="con-img flex items-center  ml-3" v-else>
						<svg
							version="1.1"
							id="Layer_1"
							width="22"
							xmlns="http://www.w3.org/2000/svg"
							xmlns:xlink="http://www.w3.org/1999/xlink"
							x="0px"
							y="0px"
							viewBox="0 0 512.001 512.001"
							style="enable-background:new 0 0 512.001 512.001;"
							xml:space="preserve"
						>
							<path
								style="fill:#F5F5F5;"
								d="M512,200.093H0V97.104c0-4.875,3.953-8.828,8.828-8.828h494.345c4.875,0,8.828,3.953,8.828,8.828
								L512,200.093L512,200.093z"
							/>
							<path
								style="fill:#FF4B55;"
								d="M503.172,423.725H8.828c-4.875,0-8.828-3.953-8.828-8.828V311.909h512v102.988
								C512,419.773,508.047,423.725,503.172,423.725z"
							/>
							<rect
								y="200.091"
								style="fill:#41479B;"
								width="512"
								height="111.81"
							/>
						</svg>
						<span class="ml-2">{{ $t("russian") }}</span>
					</div>

					<vs-dropdown-menu :fixed="true" class="vx-navbar-dropdown">
						<ul style="min-width: 9rem">
							<li
								@click="changeLang('de')"
								class="flex py-2 items-center  px-4 cursor-pointer hover:bg-primary hover:text-white"
							>
								<img
									src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAA8AgMAAADtUfddAAAACVBMVEUAAADdAAD/zgDGIigcAAAAHElEQVR4AWMAgVEwCkJxgRElMyqzChcYSTKjMgBDzfIcJWmM/AAAAABJRU5ErkJggg=="
									alt="de"
									width="22"
									height="14"
									class=""
								/>
								<span class="ml-2">{{ $t("german") }}</span>
							</li>

							<li
								@click="changeLang('en')"
								class="flex py-2 items-center  px-4 cursor-pointer hover:bg-primary hover:text-white"
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 50 30"
									width="22"
									height="14"
								>
									<clipPath id="t">
										<path
											d="M25,15h25v15zv15h-25zh-25v-15zv-15h25z"
										/>
									</clipPath>
									<path d="M0,0v30h50v-30z" fill="#012169" />
									<path
										d="M0,0 50,30M50,0 0,30"
										stroke="#fff"
										stroke-width="6"
									/>
									<path
										d="M0,0 50,30M50,0 0,30"
										clip-path="url(#t)"
										stroke="#C8102E"
										stroke-width="4"
									/>
									<path
										d="M-1 11h22v-12h8v12h22v8h-22v12h-8v-12h-22z"
										fill="#C8102E"
										stroke="#FFF"
										stroke-width="2"
									/>
								</svg>

								<span class="ml-2">{{ $t("english") }}</span>
							</li>
              
							<li
								@click="changeLang('ru')"
								class="flex items-center py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
							>
								<svg
									version="1.1"
									id="Layer_1"
									width="22"
									xmlns="http://www.w3.org/2000/svg"
									xmlns:xlink="http://www.w3.org/1999/xlink"
									x="0px"
									y="0px"
									viewBox="0 0 512.001 512.001"
									style="enable-background:new 0 0 512.001 512.001;"
									xml:space="preserve"
								>
									<path
										style="fill:#F5F5F5;"
										d="M512,200.093H0V97.104c0-4.875,3.953-8.828,8.828-8.828h494.345c4.875,0,8.828,3.953,8.828,8.828
	L512,200.093L512,200.093z"
									/>
									<path
										style="fill:#FF4B55;"
										d="M503.172,423.725H8.828c-4.875,0-8.828-3.953-8.828-8.828V311.909h512v102.988
	C512,419.773,508.047,423.725,503.172,423.725z"
									/>
									<rect
										y="200.091"
										style="fill:#41479B;"
										width="512"
										height="111.81"
									/>
								</svg>

								<span class="ml-2">{{ $t("russian") }}</span>
							</li>
						</ul>
					</vs-dropdown-menu>
				</vs-dropdown>

				<notification-drop-down
					v-if="$store.state.auth.role !== 'accountant'"
				/>

				<profile-drop-down />
			</vs-navbar>
		</div>
	</div>
</template>

<script>
import Bookmarks from "./components/Bookmarks.vue";
import SearchBar from "./components/SearchBar.vue";
import NotificationDropDown from "./components/NotificationDropDown.vue";
import ProfileDropDown from "./components/ProfileDropDown.vue";
import databaseManager from "../../../mixins/databaseManager";
import VsIcon from "../../../components/vs-icon/VsIcon.vue";
import notifier from "@/mixins/notifier";

export default {
	name: "the-navbar-vertical",
	mixins: [databaseManager, notifier],
	props: {
		navbarColor: {
			type: String,
			default: "#fff"
		}
	},
	data() {
		return {
			id: ""
		};
	},
	components: {
		Bookmarks,
		SearchBar,
		NotificationDropDown,
		ProfileDropDown,
		VsIcon
	},
	computed: {
		navbarColorLocal() {
			return this.$store.state.theme === "dark" &&
				this.navbarColor === "#fff"
				? "#10163a"
				: this.navbarColor;
		},
		verticalNavMenuWidth() {
			return this.$store.state.verticalNavMenuWidth;
		},
		textColor() {
			return {
				"text-white":
					(this.navbarColor !== "#10163a" &&
						this.$store.state.theme === "dark") ||
					(this.navbarColor !== "#fff" &&
						this.$store.state.theme !== "dark")
			};
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},

		// NAVBAR STYLE
		classObj() {
			if (this.verticalNavMenuWidth === "default")
				return "navbar-default";
			else if (this.verticalNavMenuWidth === "reduced")
				return "navbar-reduced";
			else if (this.verticalNavMenuWidth) return "navbar-full";
		}
	},
	methods: {
		async filter() {
			if (this.id !== "" && !isNaN(this.id)) {
				try {
					let requestOptions = {
						limit: 10,
						offset: 0,
						id: this.id
					};

					let dataTickets = await this.dbGetFilteredTickets(
						requestOptions
					);

					let ticketId = dataTickets.data[0].id;

					if (ticketId !== null && ticketId !== undefined) {
						this.$router.push({
							name: "TicketsCard",
							params: { id: ticketId }
						});
					}
				} catch (e) {
					this.notifyError(e.message);
				}
			} else {
				this.notifyError(this.$t("wrongField"));
			}
		},
		changeLang(locale) {
			this.$i18n.locale = locale;
			localStorage.setItem("locale", locale);
			this.$router.go(0);
		},
		showSidebar() {
			this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
		}
	}
};
</script>

<style lang="scss" scoped>
.search {
	position: relative;
	.search-icon {
		background: rgba(var(--vs-primary), 1);
		cursor: pointer;
		right: 0;
		border-top-right-radius: 4px;
		border-bottom-right-radius: 4px;
		height: 100%;
		width: 35px;
		position: absolute;
		top: 0;
		color: white !important;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;
		font-size: 22px;
	}
}
</style>
